import { Trans } from '@lingui/macro'
import Paragraph from 'Root/App/Paragraph'
import { POLICY_LANG_CONFIG } from 'lib/constants'
import getQueryString from 'lib/get-query-string'
import { useGetTermsAndConditionsUrl } from 'lib/use-get-terms-and-conditions-url'

interface SignInInfoProps {
  locale: string
  className?: string
}

const SignInInfo = ({ locale = 'en', className = '' }: SignInInfoProps) => {
  const termsAndConditionsURL = useGetTermsAndConditionsUrl()

  return (
    <Paragraph size="XS" className={className}>
      <Trans>
        Il tuo nome e la tua foto potrebbero essere visualizzati da altri utenti
        Taylora. Facendo clic su {'"'}Continua{'"'}, accetti i{' '}
        <a
          href={termsAndConditionsURL}
          target="_blank"
          className=" hover:text-gray-900 underline"
        >
          Termini e condizioni
        </a>{' '}
        e l&apos;Informativa sulla{' '}
        <a
          href={`https://www.iubenda.com/privacy-policy/${
            POLICY_LANG_CONFIG[getQueryString(locale)]
          }`}
          target="_blank"
          className=" hover:text-gray-900 underline"
          rel="noreferrer"
        >
          Privacy Policy
        </a>{' '}
        di Taylora.
      </Trans>
    </Paragraph>
  )
}

export default SignInInfo
